// extracted by mini-css-extract-plugin
export default {"form":"EmailLoginForm_form__u6QFp","forgotLink":"EmailLoginForm_forgotLink__dNrHc","buttonContainer":"EmailLoginForm_buttonContainer__3Cu4q"};